import { API_ROUTE_ADMIN_TEXT_TEMPLATES } from '@/resources/api-routes'
import { post } from '@/util/auth'

import type { TextTemplateTypeOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const postTextTemplate = (postTextTemplatePayload: Omit<TextTemplateTypeOriginal, 'id'>) =>
  post<TextTemplateTypeOriginal>(
    API_ROUTE_ADMIN_TEXT_TEMPLATES,
    postTextTemplatePayload,
    IS_NEW_BACKEND_API
  )
